import { getAppCheckToken } from "../firebase"

let lastToken = null

// The unload path can't await a fresh token, so it reuses the last one we saw.
export const getLastAppCheckToken = () => lastToken

export async function fetchWithAppCheck(input, init = {}) {
  const headers = new Headers(init.headers ?? {})

  try {
    const token = await getAppCheckToken()
    if (token) {
      headers.set("X-Firebase-AppCheck", token)
      lastToken = token
    }
  } catch (error) {
    console.warn("Could not attach App Check token:", error)
  }

  return fetch(input, { ...init, headers })
}
